import React from 'react'

const Offices = () => {
  return (
    <svg viewBox="0 0 65 65">
      <path fill="#3F5063" d="M11.7,41.5c-0.6,0-1-0.4-1-1V18.1c0-0.6,0.4-1,1-1h14.4c0.6,0,1,0.4,1,1s-0.4,1-1,1H12.7v21.4
	C12.7,41.1,12.3,41.5,11.7,41.5z"/>
      <path fill="#6EC18A" d="M26.1,46.3c-0.6,0-1-0.4-1-1V8.5c0-0.6,0.4-1,1-1h27.2c0.6,0,1,0.4,1,1v32c0,0.6-0.4,1-1,1s-1-0.4-1-1v-31H27.1
	v35.8C27.1,45.9,26.7,46.3,26.1,46.3z M46.9,35.1h-6.4c-0.6,0-1-0.4-1-1s0.4-1,1-1h6.4c0.6,0,1,0.4,1,1S47.5,35.1,46.9,35.1z
	 M46.9,28.7H32.5c-0.6,0-1-0.4-1-1s0.4-1,1-1h14.4c0.6,0,1,0.4,1,1S47.5,28.7,46.9,28.7z M46.9,22.3H32.5c-0.6,0-1-0.4-1-1
	s0.4-1,1-1h14.4c0.6,0,1,0.4,1,1S47.5,22.3,46.9,22.3z M46.9,15.9h-9.6c-0.6,0-1-0.4-1-1s0.4-1,1-1h9.6c0.6,0,1,0.4,1,1
	S47.5,15.9,46.9,15.9z"/>
      <path fill="#3F5063" d="M56.5,57.5h-48c-0.6,0-1-0.4-1-1v-16c0-0.6,0.4-1,1-1h12.8c0.6,0,1,0.4,1,1v2.4c0,0.8,0.6,1.4,1.4,1.4h17.6
	c0.8,0,1.4-0.6,1.4-1.4v-2.4c0-0.6,0.4-1,1-1h12.8c0.6,0,1,0.4,1,1v16C57.5,57.1,57.1,57.5,56.5,57.5z M9.5,55.5h46v-14H44.7v1.4
	c0,1.9-1.5,3.4-3.4,3.4H23.7c-1.9,0-3.4-1.5-3.4-3.4v-1.4H9.5V55.5z"/>
    </svg>
  )
}

export default Offices
